import { Badge, Tooltip } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { ModificationRequestItemIssueCommentForDetailFragment } from '../../../generated/graphql';
import RelativeTime from '../../connected/RelativeTime';
import UnresolvedIssueExistsIcon from './UnresolvedIssueExistsIcon';

interface Props {
  unresolvedIssueCount: number;
  latestIssueComment: ModificationRequestItemIssueCommentForDetailFragment | undefined;
}

const ModificationRequestIssueIcon = ({
  unresolvedIssueCount,
  latestIssueComment,
}: ClassAttributes<HTMLElement> & Props) => {
  return (
    <FormattedMessage id="modification_request_issue.exist">
      {(text: string) => (
        <Tooltip
          placement="top"
          title={
            <div>
              <div>{text}</div>
              {latestIssueComment && <RelativeTime datetime={latestIssueComment.createdAt} />}
            </div>
          }
        >
          <Badge badgeContent={unresolvedIssueCount} color="primary">
            <UnresolvedIssueExistsIcon size={24} />
          </Badge>
        </Tooltip>
      )}
    </FormattedMessage>
  );
};

export default ModificationRequestIssueIcon;
